import React, { useEffect, useState } from 'react'
import EmployeeTabSA from './EmployeeTabSA';
import LeaveTabSA from './LeaveTabSA';
import ProjectsTabSA from './ProjectsTabSA';
import TimeSheetSA from './TimeSheetSA';
import DSRAbsentSA from './DSRAbsentSA';
import OthersSA from './OthersSA';
import WFHTabSA from './WFHTabSA';
import { useNavigate, useLocation } from 'react-router-dom';

function SuperAdmin() {
    const navigate = useNavigate();
    const location = useLocation();
    const [currentActiveTab, setCurrentActiveTab] = useState(location.state?.tab || '1');

    const toggle = tab => {
        if (currentActiveTab !== tab) {
            setCurrentActiveTab(tab);
            navigate('/super-admin', { replace: true });
        }
    }

    useEffect(() => {
        if (location.state?.tab) {
           setCurrentActiveTab(location.state.tab);
        }
    }, [location.state?.tab])

    const TabButton = ({ id, label }) => (
        <button
            type="button"
            onClick={() => toggle(id)}
            className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                currentActiveTab === id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div id="main-scroll-container" className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
            <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-2 sm:py-2 flex-1 w-full flex flex-col mb-2">
                <div className="sticky top-0 z-10 bg-[#f6f6f6] pb-3 pt-2 -mt-2 -mx-2 sm:-mx-4 px-2 sm:px-4">
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        <div className="flex overflow-x-auto scrollbar-hide">
                            <TabButton id="1" label="Employee" />
                            <TabButton id="2" label="Leave" />
                            <TabButton id="3" label="WFH" />
                            <TabButton id="4" label="Projects" />
                            <TabButton id="5" label="TimeSheet" />
                            <TabButton id="6" label="Office Holidays" />
                            <TabButton id="8" label="DSR Compliance" />
                        </div>
                    </div>
                </div>

                <div className="flex-1">
                    {currentActiveTab === '1' && <EmployeeTabSA />}
                    {currentActiveTab === '2' && <LeaveTabSA />}
                    {currentActiveTab === '3' && <WFHTabSA />}
                    {currentActiveTab === '4' && <ProjectsTabSA />}
                    {currentActiveTab === '5' && <TimeSheetSA />}
                    {currentActiveTab === '6' && <OthersSA />}
                    {currentActiveTab === '8' && <DSRAbsentSA />}
                </div>
            </div>
        </div>
    )
}

export default SuperAdmin